
jQuery( document ).ready( function() {
	// let slugTitle = '';

	function check_Undefined( item, type = 'normal' ) {
		if ( typeof item === 'undefined' ) {
			if ( type === 'page' ) {
				item = 1;
			} else {
				item = '';
			}
		}
		return item;
	}

	// let paractes = '';
	// let search = '';

	// Click event handler for both titles and practices areas
	jQuery( document ).on( 'click', '.attorneys-filter', function() {
		filterFunction();
	} );
	jQuery( 'form#searchform' ).submit( function( e ) {
		e.preventDefault( e );
	} );
	jQuery( document ).on( 'keyup', '.search-attorney', function( e ) {
		if ( e.which == 13 ) {
			e.preventDefault();
			filterFunction();
		}
	} );
	function filterFunction() {
		const title_attorney = check_Undefined( jQuery( '#titles' ).find( 'li.select-dropdown__sort-item.active-list' ).attr( 'data-slug' ) );
		const category_attorney = check_Undefined( jQuery( '#practices' ).find( 'li.select-dropdown__sort-item.active-list' ).attr( 'data-slug' ) );
		const search = jQuery( '#search-attorney' ).val();

		if ( history.pushState ) {
			let oldurl = window.location.protocol + '//' + window.location.host + window.location.pathname;

			if ( category_attorney !== '' && title_attorney !== '' ) {
				oldurl += '?category-attorney=' + category_attorney + '&title-attorney=' + title_attorney;
			} else if ( category_attorney !== '' ) {
				oldurl += '?category-attorney=' + category_attorney;
			} else if ( title_attorney !== '' ) {
				oldurl += '?title-attorney=' + title_attorney;
			}
			// Add search parameters if needed
			if ( search !== '' ) {
				if ( oldurl.includes( '?' ) ) {
					oldurl += '&search=' + search;
				} else {
					oldurl += '?search=' + search;
				}
			}
			window.history.pushState( { path: oldurl }, '', oldurl );
		}

		//console.log( search );
		jQuery( '.lds-roller' ).show();
		jQuery( '#attorneybios-container' ).empty();

		jQuery.ajax( {

			url: localVars.ajax_url,
			type: 'post',
			dataType: 'json',
			data: {
				action: 'attorneys_filter',
				data: {
					category_attorney,
					title_attorney,
					search,
				},
			},

			success( response ) {
				jQuery( '.lds-roller' ).hide();
				if ( response ) {
					jQuery( '#attorneybios-container' ).html( response.html );
				} else {
					jQuery( '#attorneybios-container' ).html(
						'Oops, we could not find any results for your search.'
					);
				}
			},
			error( response ) {},
		} );
	}
} );
